<template>
  <div>
    <h5 class="mb-3 font-weight-bold">Select Jurisdiction</h5>
    <div v-if="formattedOptions.length === 0" class="d-flex flex-wrap">
      <div
          v-for="n in 3"
          :key="n"
          class="skeleton-pill mr-2 mb-2"
      ></div>
    </div>
    <GroupedOptions
        v-model="internalValue"
        :options="formattedOptions"
        native-type="checkbox"
        button-classes="badge badge-pill mr-2 mb-2 text-capitalize"
        :disabled="loading"
    />
  </div>
</template>

<script>
import GroupedOptions from "@components/GroupedOptions";

export default {
  components: { GroupedOptions },
  props: {
    value: { type: Array, default: () => [] },
    loading: Boolean,
    options: { type: Array, default: () => [] },
  },
  data() {
    return {
      isInitialLoad: true,
    }
  },
  computed: {
    formattedOptions() {
      return this.options.map(opt => ({ label: opt, value: opt }));
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        // Prevent deselecting all
        if (val.length === 0) return;
        this.$emit('input', [...val]);
      }
    }
  },
};
</script>

<style lang="scss">
.skeleton-pill {
  width: 75px;
  height: 25px;
  margin-bottom: 0.5rem;
  border-radius: 15px;
  background: linear-gradient(
          -90deg,
          #eeeeee 0%,
          #dee2e6 50%,
          #eeeeee 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
